<p-button
  [type]="type()"
  [disabled]="isDisabled()"
  [severity]="severity()"
  [outlined]="outlined()"
  [size]="pSize()"
  [label]="effectiveLabel()"
  [ariaLabel]="accessibleLabel()"
  [icon]="icon()"
  [iconPos]="iconPos()"
  [fluid]="fluid()"
  [loading]="loading()"
  [text]="variant() === 'ghost'"
>
  <ng-content />
</p-button>
